<script lang="ts" setup>
defineProps({
  width: {
    type: String,
    default: '24',
  },
});
</script>

<template>
  <svg
    :width="width"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M8.55002 12C7.48002 11.29 6.30002 10.73 5.02002 10.39C6.30002 10.73 7.48002 11.29 8.55002 12ZM18.98 10.39C17.69 10.73 16.49 11.3 15.41 12.03C16.49 11.3 17.69 10.73 18.98 10.39Z"
        fill="currentColor"
      />
      <path
        d="M15.49 9.63C15.31 6.84 14.18 4.12 12.06 2C9.92 4.14 8.74 6.86 8.51 9.63C9.79 10.31 10.97 11.19 12 12.26C13.03 11.2 14.21 10.32 15.49 9.63ZM8.99 12.28C8.85 12.18 8.69 12.09 8.54 11.99C8.69 12.1 8.85 12.18 8.99 12.28ZM15.41 12.03C15.28 12.12 15.14 12.19 15.01 12.29C15.14 12.19 15.28 12.12 15.41 12.03ZM12 15.45C9.85 12.17 6.18 10 2 10C2 15.32 5.36 19.82 10.03 21.49C10.66 21.72 11.32 21.89 12 22C12.68 21.88 13.33 21.71 13.97 21.49C18.64 19.82 22 15.32 22 10C17.82 10 14.15 12.17 12 15.45Z"
        fill="currentColor"
      />
    </g>
  </svg>
</template>
